// extracted by mini-css-extract-plugin
export var dropdown = "MultiSelect-module--dropdown--992c5";
export var input = "MultiSelect-module--input--be246";
export var option = "MultiSelect-module--option--41035";
export var pill = "MultiSelect-module--pill--cef50";